import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import NoticeCard from './NoticeCard'

const CertificationNotice = ({ notFound }) => {
  const { t } = useTranslation()

  return (
    <NoticeCard
      icon={notFound ? 'fa fa-graduation-cap' : 'fa fa-exclamation-circle'}
      title={t(notFound ? 'portal.certification.comingSoonTitle' : 'portal.certification.loadFailedTitle')}
      body={t(notFound ? 'portal.certification.comingSoonBody' : 'common.somethingWentWrong')}
    />
  )
}

CertificationNotice.propTypes = {
  notFound: PropTypes.bool.isRequired,
}

export default CertificationNotice
